import { render, staticRenderFns } from "./EditPickupAddress.vue?vue&type=template&id=5262cb69&"
import script from "./EditPickupAddress.vue?vue&type=script&lang=ts&"
export * from "./EditPickupAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports